export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7348___OF_ASSOCIATIONS': '# of Associations',
    '_7333___OF_COMMITMENTS': '# of Commitments',
    '_7315___OF_EVALUATIONS': '# of Evaluations',
    '_7318___OF_GOALS': '# of Goals',
    '_7380___OF_INTERACTIONS': '# of Interactions',
    '_7314___OF_OBSERVATIONS': '# of Observations',
    '_7356___OF_RECORDS_DISPLAYED': '# of Records Displayed',
    '_7325___IMPROVEMENT__INIT_': '% Improvement (init)',
    '_7367___TO_GOAL': '% To Goal',
    '_767___TO_GOAL': '% to Goal',
    '_7386___TO_GOAL__CURRENT_': '% to Goal (Current)',
    '_7384___TO_GOAL__INITIAL_': '% to Goal (Initial)',
    '_7324___TO_GOAL__INIT_': '% to Goal (init)',
    '_768___TO_TARGET': '% to Target',
    '_7429__CLOSEST_TO_FURTHEST____TO_GOAL': '(Closest to Furthest) % to Goal',
    '_7431__CLOSEST_TO_FURTHEST____TO_TARGET': '(Closest to Furthest) % to Target',
    '_7430__FURTHEST_TO_CLOSEST____TO_GOAL': '(Furthest to Closest) % to Goal',
    '_7432__FURTHEST_TO_CLOSEST____TO_TARGET': '(Furthest to Closest) % to Target',
    '_7434__LEAST_TO_MOST____OF_OPPORTUNITIES': '(Least to Most) # of Opportunities',
    '_7433__MOST_TO_LEAST____OF_OPPORTUNITIES': '(Most to Least) # of Opportunities',
    '_7445__30_DAY_ROLLING': '30 Day Rolling',
    '_125_ACTIVE': 'Active',
    '_725_ACTUAL': 'Actual',
    '_7385_ACTUAL__CURRENT_': 'Actual (Current)',
    '_7383_ACTUAL__INITIAL_': 'Actual (Initial)',
    '_7326_ACTUAL__INIT_': 'Actual (init)',
    '_7456_ACTUAL_LINE': 'Actual Line',
    '_7311_AGING': 'Aging',
    '_109_ALL': 'All',
    '_7404_ALL_COMPONENTS_SELECTED': 'All Components Selected',
    '_7362_APPLY': 'Apply',
    '_7303_APPLY_FILTERS': 'Apply Filters',
    '_7334_BEHAVIOUR': 'Behaviour',
    '_7437_BOTH': 'Both',
    '_7408_CHANGE_VIEW': 'Change View',
    '_7363_CLEAR': 'Clear',
    '_7304_CLEAR_FILTERS': 'Clear Filters',
    '_763_CLOSE': 'Close',
    '_7440_CLOSED': 'Closed',
    '_7331_CLOSED_ON': 'Closed On',
    '_7308_COACH': 'Coach',
    '_7394_COACHED_OA': 'Coached OA',
    '_7371_COACHED_OPPORTUNITIES': 'Coached - Expected Opportunities',
    '_7378_COMMITMENT_DETAILS': 'Commitment Details',
    '_7346_COMMITMENT_NAME': 'Commitment Name',
    '_7312_COMMITMENT_START_DATE': 'Commitment Start Date',
    '_7337_COMMITMENT_STATUS': 'Commitment Status',
    '_7453_COMMITMENTS': 'Commitments',
    '_7345_COMPLETION_DATE': 'Completion Date',
    '_7402_COMPONENT': 'Component',
    '_7342_COMPONENT_NAME': 'Component Name',
    '_7316_CONSISTENCY': 'Consistency',
    '_7330_CREATED_BY': 'Created By',
    '_7329_CREATED_ON': 'Created On',
    '_7365_CREATOR': 'Creator',
    '_7461_CURR__PERIOD_START': 'Curr. Period Start',
    '_4106_CURRENT_ACTUAL': 'Current Actual',
    '_7389_CURRENT_COMMITMENTS': 'Current Commitments',
    '_7460_CURRENT_PERIOD': 'Current Period',
    '_202_DAILY': 'Daily',
    '_709_DATE_RANGE': 'Date Range',
    '_7341_DAYS_AGING_AS_OPPORTUNITY': 'Days Aging as Opportunity',
    '_7374_DAYS_IN_SUPERGROUP': 'Days in Supergroup',
    '_7409_DEFAULT_VIEW__SELF_': 'Default View (self)',
    '_555_DETAIL': 'Detail',
    '_746_DETAILS': 'Details',
    '_7332_DISPOSITION': 'Disposition',
    '_7353_EFFORT_DEMONSTRATED': 'Effort Demonstrated',
    '_7387_EST__COMPLETION': 'Est. Completion',
    '_7328_EST__COMPLETION_DATE': 'Est. Completion Date',
    '_7370_EXPECTED_COACHING': 'Expected Coaching',
    '_7427_EXPECTED_OPPORTUNITIES': 'Expected Opportunities',
    '_7447_FAILED_TO_LOAD_DATA': 'Failed to Load Data',
    '_7360_FILTER': 'Filter',
    '_7300_FILTERED_BY': 'Filtered by',
    '_7361_FOCUS': 'Focus',
    '_7351_FOCUS_EVALUATED': 'Focus Evaluated',
    '_7450_FULL': 'Full',
    '_7369_GAP_TO_OPPORTUNITY_LINE': 'Gap to Opportunity Line',
    '_721_GOAL': 'Goal',
    '_7321_GOAL_CREATED_ON': 'Goal Created On',
    '_7381_GOAL_DETAILS': 'Goal Details',
    '_7458_GOAL_LINE': 'Goal Line',
    '_7382_GOAL_START_DATE': 'Goal Start Date',
    '_7320_GOAL_STATUS': 'Goal Status',
    '_7454_GOALS': 'Goals',
    '_7393_HIDE_COACHING_HISTORY': 'Hide Coaching History',
    '_7335_HIDE_COMMITMENTS': 'Hide Commitments',
    '_7319_HIDE_GOALS': 'Hide Goals',
    '_7352_HIDE_EVALUATIONS': 'Hide evaluations',
    '_7350_INTERACTION_DATE': 'Interaction Date',
    '_7349_INTERACTION_TYPE': 'Interaction Type',
    '_7313_LAST_UPDATE': 'Last Update',
    '_7391_LEGEND': 'Legend',
    '_7355_LOADING_PERFORMERS_': 'Loading Performers...',
    '_7439_MTD': 'MTD',
    '_48_MANAGER': 'Manager',
    '_713_METRIC': 'Metric',
    '_7340_METRIC_ID': 'Metric ID',
    '_7339_METRIC_NAME': 'Metric Name',
    '_527_METRICS': 'Metrics',
    '_204_MONTHLY': 'Monthly',
    '_7403_MULTIPLE_COMPONENTS_SELECTED': 'Multiple Components Selected',
    '_842_N_A': 'N/A',
    '_7390_NO_COMMITMENTS_AVAILABLE': 'No Commitments Available',
    '_852_NO_DATA': 'No Data',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7366_NO_DATA_': 'No Data.',
    '_7410_NO_FAVOURITES_SAVED': 'No Favourites saved',
    '_7343_NO_GOAL': 'No Goal',
    '_7449_NO_OA': 'No OA',
    '_7400_NO_OPPORTUNITIES_NEED_ATTENTION_': 'No Opportunities need attention.',
    '_7413_NO_RESULTS_FOUND': 'No Results Found',
    '_7323_NO_RESULTS_': 'No Results.',
    '_7465_NON_KPI': 'Non-KPI',
    '_7396_NON_OA': 'Non-OA',
    '_7376_NON_OA_GOALS': 'Non-OA Goals',
    '_7436_NON_OPPORTUNITY': 'Non-Opportunity',
    '_7464_NON_OPPORTUNITY_COACHING': 'Non-Opportunity Coaching',
    '_7463_OA': 'OA',
    '_7375_OA_GOALS': 'OA Goals',
    '_7444_OTHERS': 'OTHERS',
    '_7379_OBSERVATION_DETAILS': 'Observation Details',
    '_7377_OBSERVATIONS': 'Observations',
    '_7347_OBSERVER': 'Observer',
    '_7435_OPPORTUNITY': 'Opportunity',
    '_7459_OPPORTUNITY_LINE': 'Opportunity Line',
    '_7368_OPPORTUNITY_THRESHOLD': 'Opportunity Threshold',
    '_7466_OTHER_COMMITMENTS': 'Other Commitments',
    '_7472_OTHERS': 'Others',
    '_7451_PARTIAL': 'Partial',
    '_7452_PARTIAL_NO_OA': 'Partial No OA',
    '_7441_PENDING_CLOSE': 'Pending Close',
    '_773_PERIOD': 'Period',
    '_7467_PLEASE_SELECT': 'Please Select',
    '_7428_PLEASE_SELECT_SORT': 'Please Select Sort',
    '_7462_PLEASE_SELECT_A_METRIC': 'Please Select a Metric',
    '_7397_PLEASE_SELECT_A_METRIC_BELOW': 'Please Select a Metric below',
    '_7448_PLEASE_SELECT_': 'Please Select...',
    '_7302_PLEASE_ADD_FILTER_OPTIONS': 'Please add Filter options',
    '_7412_PLEASE_PROVIDE_A_CLICKABLE_ELEMENT_WITH_A__VIEWTRIGGER__ATTRIBUTE': 'Please provide a clickable element with a [viewTrigger] attribute',
    '_7317_PROFICIENCY': 'Proficiency',
    '_7446_QTD': 'QTD',
    '_59_ROLE': 'Role',
    '_7442_SELF': 'SELF',
    '_7407_START_COMMITMENT': 'START COMMITMENT',
    '_7406_START_OBSERVATION': 'START OBSERVATION',
    '_710_SEARCH': 'Search',
    '_7401_SELECT_METRIC_': 'Select Metric...',
    '_7405_SELECT_PERIOD_': 'Select Period...',
    '_7470_SELF': 'Self',
    '_7310_SESSION_DATE': 'Session Date',
    '_7309_SESSION_TYPE': 'Session Type',
    '_7338_SHOW_COMMITMENTS': 'Show Commitments',
    '_7354_SHOW_EVALUATIONS': 'Show Evaluations',
    '_7322_SHOW_GOALS': 'Show Goals',
    '_7357_SHOWING': 'Showing',
    '_7301_SORT_BY': 'Sort By',
    '_75_START_DATE': 'Start Date',
    '_9774_START_DATE_': 'Start Date:',
    '_127_STATUS': 'Status',
    '_7364_SUB_BEHAVIOUR': 'Tactic',
    '_7336_SUB_BEHAVIOUR': 'Tactic',
    '_67_SUPERGROUP': 'SuperGroup',
    '_7373_SUPERGROUP_NAME': 'Supergroup Name',
    '_7443_TEAM': 'TEAM',
    '_726_TARGET': 'Target',
    '_7327_TARGET__INIT_': 'Target (init)',
    '_7457_TARGET_LINE': 'Target Line',
    '_7471_TEAM': 'Team',
    '_7469_THIS_PERSON_ALREADY_HAS_SEVERAL_COMMITMENTS__ARE_YOU_SURE_YOU_WANT_TO_ADD_ANOTHER_': 'This person already has several commitments. Are you sure you want to add another?',
    '_7468_THIS_PERSON_ALREADY_HAS_TOO_MANY_COMMITMENTS__PLEASE_CLOSE_SOME_BEFORE_OPENING_ANOTHER': 'This person already has too many commitments. Please close some before opening another',
    '_7372_TOTAL_OPPORTUNITIES': 'Total Opportunities',
    '_7359_TOTAL_RECORDS': 'Total Records',
    '_989_TREND': 'Trend',
    '_7388_UNABLE_TO_RETRIEVE_DATA_FOR_COMMITMENT': 'Unable to retrieve data for Commitment',
    '_7395_UNCOACHED_OA': 'Uncoached OA',
    '_7399_UNCOACHED_OPPORTUNITIES': 'Uncoached Opportunities',
    '_7398_VARIANCE': 'Variance',
    '_7455_VARIANCE_LINE': 'Variance Line',
    '_7392_VIEW_COACHING_HISTORY': 'View Coaching History',
    '_715_WTD': 'WTD',
    '_203_WEEKLY': 'Weekly',
    '_7411_CMPS_UI_DROPDOWN': 'cmps-ui-dropdown',
    '_7305_FOR': 'for',
    '_7438_MONTH': 'month',
    '_7358_OF': 'of',
    '_7473_COACHED_OPPORTUNITIES': 'Coached Opportunities',
    '_7475_UP_TO_DATE': 'Up To Date',
    '_7474_GET_UPDATES': 'Get Updates',
    '_7476_TOTAL_OPPORTUNITIES': 'Total Opportunities',
    '_7477_TOTAL_COACHED_OPPORTUNITIES': 'Total Coached Opportunities',
    '_7478_TOTAL_UNCOACHED_OPPORTUNITIES': 'Total Uncoached Opportunities',
    '_7479_NO_METRICS_': 'No Metrics.',
    '_7480_NO_TEAM_': 'No Team.',
    '_7481_FUNDED_COACHED_OPPORTUNITIES': 'Funded Coached Opportunities',
    '_7482_EXPECTED_OPPORTUNITIES': 'Expected Opportunities',
    '_7483___OF_MY_MANAGER_S_COACHED_OPPORTUNITIES': '% of my Manager\'s Coached Opportunities',
    '_7484___OF_MY_MANAGER_S_UNCOACHED_OPPORTUNITIES': '% of my Manager\'s Uncoached Opportunities',
    '_7485_METRIC_FOCUS': 'Metric Focus',
    '_7486_CLOSE_METRIC_FOCUS': 'Close Metric Focus',
    '_7487_OPPORTUNITIES': 'Opportunities',
    '_7488_COACHED': 'Coached',
    '_7489_UNCOACHED': 'Uncoached',
    '_7491_EXPECTED_OPPS_': 'Expected Opps.',
    '_7492_OPPORTUNITY_FUNDED_COACHING': 'Opportunity Funded Coaching',
    '_7493_TOTAL_AGENTS': 'Total Agents',
    '_7494___OF_AGENTS_WITH_OPPORTUNITIES': '% of Agents with Opportunities',
    '_7495_BACK_TO_PREVIOUS_VIEW': 'Back to Previous View',
    '_7496_COACHING_INDICATOR': 'Coaching Indicator',
    '_7497_NUMB_OF_COMPONENTS': 'Num of Components',
    '_7498_CLOSED_GOAL_STILL_AN_OPPORTUNITY': 'Closed Goal Still an Opportunity',
    '_7499_CLOSED_GOAL_NO_LONGER_AN_OPPORTUNITY': 'Closed Goal No Longer an Opportunity',
    '_7500_EXPIRED_OPPORTUNITY': 'Expired Opportunity',
    '_7501_COACHING_ON_COMPONENT_METRIC': 'Coaching on Component Metric',
    '_7502_PENDING_GOAL': 'Pending Goal',
    '_7503_OPPORTUNITY_STATUS': 'Opportunity Status',
    '_7504_INTERVENTION_DAYS_USED': 'Intervention Days Used',
    '_7505_INTERVENTION_DAYS_LEFT': 'Intervention Days Left',
    '_7506_PERCENT_TO_INTERVENTION': 'Percent to Intervention',
    '_7507_OPEN_DAYS': 'Open Days',
    '_7508_MISSED_OPPORTUNITIES': 'Missed Opportunities',
    '_7509_DEFAULT_VIEW': 'Default View',
    '_7510_SHOW_PREVIOUS_DIRECT_REPORTS': 'Show Previous Direct Reports',
    '_7511_COLUMNS': 'Columns',
    '_7512_PEOPLE': 'People',
    '_7513_LEFT_OA': 'Left OA',
    '_7514_CHANGED_SUPERGROUPS': 'Changed Supergroups',
    '_7515_METRIC_REMOVED_FROM_OA': 'Metric removed from OA',
    '_7516_OPPORTUNITY_CLOSED': 'Opportunity closed as no Metric data received',
    '_7517_USER_OPPORTUNITY_CLOSED_AS_USER_WAS_ABSENT': 'Users Opportunity closed as user was absent',
    '_7518_OPPORTUNITY_CLOSED_BECAUSE_PERFORMANCE_IMPROVED': 'Opportunity closed because performance improved',
    '_7519_COMPACT_VIEW': '',
    '_7520_FULL_VIEW': '',
    '_7521_HIDE_COLUMN': '',
    '_7522_EXPIRED': 'Expired',
    '_76_TYPE': 'Type',
    '_7533_COMMITMENT': 'Commitment',
    '_9775_NEW_COMMITMENT': 'New Commitment',
    '_9776_EDIT_COMMITMENT': 'Edit Commitment',
    '_9596_SELECT_A_BEHAVIOUR': 'Select a Behaviour',
    '_9597_SELECT_A_SUB_BEHAVIOUR': 'Select a Tactic',
    '_9777_CLICK_HERE_TO_SET_THE_FOCUS_FOR_THIS_COMMITMENT': 'Click here to set the Focus for this Commitment',
    '_9598__DRAFT_': '(Draft)',
    '_9599_OVERALL_COACHING_PERCENT': 'Overall Coaching Coverage %',
    '_830_DAY': 'Day',
    '_829_WEEK': 'Week',
    '_828_MONTH': 'Month',
    '_7137__30_DAY_ROLLING': '30 Day Rolling',
    '_201_QUARTER': 'Quarter',
    '_207_YEAR': 'Year',
    '_9600_COACHING_COVERAGE_PERCENT': 'Coaching Coverage %',
    '_9601_OBSERVATION_COVERAGE_PERCENT': 'Observation Coverage %',
    '_9602_COMMITMENT_COVERAGE_PERCENT': 'Commitment Coverage %',
    '_9603_OTHER': 'Other',
    '_9604_SELECT_THE_PERIOD__WEEK__YOU_WANT_TO_SEE': 'Select the Period (week) you want to see',
    '_9253_TO': 'to',
    '_9605_CREATE_EVENT': 'Create Event',
    '_9606_SCHEDULE': 'Schedule',
    '_9607_WEEKS': 'Weeks',
    '_9608_PREVIOUS_WEEK': 'Previous weeks',
    '_9609_NEXT_WEEK': 'Next weeks',
    '_9610_SELECT_A_FOCUS': 'Select a Focus',
    '_9778_SELECT_A_METRIC': 'Select a Metric',
    '_9611_RECENTLY_CLOSED_FOCUSES_FOR_THIS_PERFORMER': 'Recently Closed Focuses for this performer',
    '_9612_ACTIVE_FOCUS_FOR_THIS_PERFORMER': 'Active Focus for this performer',
    '_9613_RECENT_FOCUS_FOR_TEAM': 'Recent Focus for team',
    '_9614_PLEASE_ENTER_3_CHARACTERS_OR_MORE_FOR_THE_SEARCH_TO_PROCEED': 'Please enter 3 characters or more for the search to proceed',
    '_9615_THIS_BEHAVIOUR_HAS_NO_SUB_BEHAVIOURS': 'This Behaviour has no Tactics',
    '_9616_FOCUS_KPIS__METRICS_': 'Focus Metrics',
    '_9617_ON_SCORECARD': 'On Scorecard',
    '_9618_SELECTED_BEHAVIOUR___SUB_BEHAVIOUR_': 'Selected Behaviour + Tactic:',
    '_9619_SELECTED_KPIS_': 'Selected Metrics:',
    '_9620_SET_SELECTED_FOCUS': 'Set Selected Focus',
    '_9621_ADD_SELECTED_METRICS': 'Add Selected Metrics',
    '_9622_BEHAVIOUR___SUB_BEHAVIOUR_FOCUS': 'Behaviour - Tactic Focus',
    '_9623_OBSERVE_A_NEW_INTERACTION': 'Observe a new interaction',
    '_9624_ADD_ANOTHER_METRIC': 'Add another metric',
    '_9779_EXPECTED_ACHIEVEMENT_DATE': 'Expected Achievement Date',
    '_7454_KPIS': 'Goals',
    '_9625_CREATE_A_NEW_FOCUS': 'Create a new Focus',
    '_9780_LINK_ANOTHER_OBSERVATION': 'Link another Observation',
    '_9781_START_A_NEW_OBSERVATION': 'Start a new Observation',
    '_9782_UNLINK_OBSERVATION': 'Unlink Observation',
    '_9626_REVIEW_OBSERVATION': 'Review Observation',
    '_9627_OBSERVER_': 'Observer:',
    '_9783_DATE_': 'Date:',
    '_965_DATE': 'Date',
    '_9577_NOTES_': 'Notes:',
    '_9784_NOTES': 'Notes',
    '_9628_INTERACTIONS_': 'Interactions:',
    '_9785_INTERACTIONS': 'Interactions',
    '_9629_OBSERVATION_REVIEW': 'Observation Review',
    '_121_CANCEL': 'Cancel',
    '_9630_SHARE': 'Share',
    '_7425_EDIT': 'Edit',
    '_7424_DELETE': 'Delete',
    '_9415_PUBLISH': 'Publish',
    '_9416_SAVE_DRAFT': 'Save Draft',
    '_9417_DURATION_': 'Duration:',
    '_9631_PREV': 'Prev',
    '_9632_NEXT': 'Next',
    '_9633_CONFIDENCE_LEVEL': 'Confidence Level',
    '_9634_LINK': 'Link',
    '_9418_UNLINK': 'Unlink',
    '_9635__READ_ONLY_': '(Read Only)',
    '_9636__EDIT_MODE_': '(Edit Mode)',
    '_9637_EXIT_EDIT_MODE': 'Exit Edit Mode',
    '_9548_OBSERVATION': 'Observation',
    '_9419_TYPE_': 'Type:',
    '_9638_FOCUS_CONTAINERS_': 'Focus Containers:',
    '_9639_EVALUATIONS_': 'Evaluations:',
    '_9420_STATUS_': 'Status:',
    '_9640_FOCUS_KPIS_': 'Focus Metrics:',
    '_9641_UPDATE_OBSERVATION': 'Update Observation',
    '_9642_DEMONSTRATED_EFFORT': 'Demonstrated Effort',
    '_9567_OPPORTUNITY_TO_DEMONSTRATE': 'Opportunity to Demonstrate',
    '_9643_OPP__TO_DEMONSTRATE': 'Opp. to Demonstrate',
    '_9568_WILLINGNESS_TO_TRY': 'Willingness to Try',
    '_9644_PROFICIENCY_SCORE': 'Proficiency Score',
    '_9645_CONSISTENCY_SCORE': 'Consistency Score',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9421_PUBLISHED_OBSERVATIONS': 'Published Observations',
    '_9646_EVALUATE_INTERACTION_FOCUS': 'Evaluate Interaction Focus',
    '_9647_INTERACTION_FOCUS_EVALUATION': 'Interaction Focus Evaluation',
    '_9113_PUBLISHED': 'Published',
    '_9422_BEHAVIOUR_': 'Behaviour:',
    '_9423_SUB_BEHAVIOUR_': 'Tactic:',
    '_9424_COMMITMENT_FOCUS': 'Commitment Focus',
    '_9649_NO_OBSERVATIONS': 'No observations',
    '_9650_THIS_FOCUS_ALREADY_EXISTS__DO_YOU_WANT_TO_MOVE_THE_ITEMS_TO_THIS_FOCUS_': 'This focus already exists. Do you want to move the items to this focus?',
    '_9651_A_NEW_FOCUS_CONTAINER_HAS_BEEN_CREATED_WITH_YOUR_FOCUS_SELECTION': 'A new focus container has been created with your focus selection',
    '_9425_OK': 'OK',
    '_9652_INTERACTION_REF': 'Interaction Ref',
    '_9653_COMMITTED_GOAL_S_': 'Committed Goal(s)',
    '_9426_ACTIVE_GOALS': 'Active Goals',
    '_9654_FOCUS_METRIC': 'Focus Metric',
    '_9655_NO_ACTIVE_GOALS': 'NO ACTIVE GOALS',
    '_9656_NO_FOCUS_METRIC': 'NO FOCUS METRICS',
    '_9427_GOAL_METRIC': 'Goal Metric',
    '_9558_THIS_METRIC_DOES_NOT_HAVE_A_GOAL_ON_AN_ACTIVE_COMMITMENT_': 'This metric does not have a goal on an active commitment.',
    '_9557_DO_YOU_WANT_TO_OBSERVE_OR_COMMIT_A_NEW_FOCUS_FOR_THIS_METRIC_': 'Do you want to Observe or Commit a New Focus for this Metric?',
    '_9429_SHOW_SUPERGROUP_AVG': 'Show Supergroup Avg.',
    '_9430_NO_METRIC_PERFORMANCE_DATA': 'No Metric Performance Data.',
    '_9431__IMPROVEMENT_EXPECTED': '% Improvement Expected',
    '_9432_GOAL_VALUE': 'Goal Value',
    '_9433_START___TO_GOAL': 'Start % to Goal',
    '_9434_DAYS_TO_ACHIEVEMENT': 'Days to Achievement',
    '_9435_TOTAL_DAYS_OPPORTUNITY_ACTIVE': 'Total Days Opportunity Active',
    '_9436_GOAL_CREATOR': 'Goal Creator',
    '_9437_UPDATE_GOAL': 'Update Goal',
    '_9438_SEE_GOAL_HISTORY': 'See Goal History',
    '_9439_DELETE_THIS_GOAL': 'Delete This Goal',
    '_9440_CLOSE_THIS_GOAL': 'Close This Goal',
    '_9441_ACCEPT_CHANGES': 'Accept Changes',
    '_9442_CANCEL_REVIEW': 'Cancel Review',
    '_9443_DECLINE_CHANGES': 'Decline Changes',
    '_9444_THIS_GOAL_IS_BEING_SHARED_ACROSS_OTHER_COMMITMENTS__SEE_THE_OTHER_COMMITMENT_HERE_': 'This goal is being shared across other commitments, see the other commitment here.',
    '_9445_IMPROVEMENT_SINCE_LAST_GOAL': 'Improvement Since Last Goal',
    '_9446_OVERALL_IMPROVEMENT': 'Overall Improvement',
    '_9447_CREATE_NEW_GOAL': 'Create a New Goal',
    '_9448_GOAL_REVIEW': 'Goal Review',
    '_9449_GOAL_UPDATE': 'Goal Update',
    '_9450_ASSOCIATE_GOAL': 'Associate Goal',
    '_9451_SET_NEW_GOAL': 'Set New Goal',
    '_9452_SET_UPDATED_GOAL': 'Set Goal',
    '_9453_FROM_ANOTHER_COMMITMENT_': 'from another Commitment',
    '_9454_ACTIVE_GOAL': 'Active Goal',
    '_9455_HISTORIC_GOALS': 'Historic Goals',
    '_9456_OBSERVATION_EVENT': 'Observation Event',
    '_9457_COMMITMENT_EVENT': 'Commitment Event',
    '_9458_MULTIPLE_COACHING_EVENTS': 'Multiple Coaching Events',
    '_7313_LAST_UPDATED_': 'Last Update',
    '_9459_NEXT_COACHING_EVENT_': 'Next Coaching Event',
    '_9460_NO_UPDATES_YET': 'No updates yet',
    '_9461_NO_EVENT_SCHEDULE': 'No event scheduled',
    '_9462_DATE_SET': 'Date Set',
    '_9463_ACTIVE_GOAL_DAYS': 'Active Goal Days',
    '_9657_GOAL_BUILDER': 'Goal Builder',
    '_9466_GOALS_ON_OTHER_COMMITMENTS': 'Goals on Other Commitments',
    '_9467_RECENTLY_CLOSED_GOALS': 'Recently Closed Goals',
    '_9468_SORT': 'Sort',
    '_714_30_DAY': '30 Day',
    '_9469_SESSION_TIME': 'Session Time',
    '_9470_TOTAL_TIME': 'Total Time',
    '_9471_APPROVE': 'Approve',
    '_9472_DISPUTE': 'Dispute',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_9474_SELECT_GOAL_METRIC': 'Select Goal Metric',
    '_9475_PENDING_GOALS': 'Pending Goals',
    '_9476_DRAFT': 'Draft',
    '_9658_SET_FOCUS': 'Set Focus',
    '_9659_STAR_THIS_STORY': 'Star this Story',
    '_9660_COPY_NOTES_TO_NEW_FOCUS': 'Copy notes to New Focus',
    '_9661_SCORES_FROM_THIS_SESSION': 'Scores from This Session',
    '_9662_PENDING_OVERALL': 'Pending Overall',
    '_9477_THE_FOCUS_CANNOT_BE_CHANGED_': 'The focus cannot be changed.',
    '_9478_THE_FOCUS_YOU_HAVE_SELECTED_IS_ALREADY_A_FOCUS_FOR_AN_ACTIVE_COMMITMENT': 'The focus you have selected is already a focus for an active commitment for the performer .Please select a different commitment focus.',
    '_9579_FOCUS_CONTAINER__UNFOCUSED_': 'Focus Container (Unfocused)',
    '_9663_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_FOCUS_CONTAINER_': 'Are you sure you want to delete this Focus Container?',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9664_NON_OPPORTUNITIES': 'Non-Opportunities',
    '_9665_RESET': 'Reset',
    '_9666_ARE_YOU_SURE_YOU_WANT_TO_RESET_EVALUATION_TO_PREVIOUS_VALUE_': 'You are about to reset your evaluation. This will remove your score from this interaction.',
    '_9480_SUPERGROUP_AVERAGE': 'Supergroup Average',
    '_9554_START_GENERIC_OBSERVATION': 'Start Generic Observation',
    '_9555_START_GENERIC_COMMITMENT': 'Start Generic Commitment',
    '_9481_START_TIME_': 'Start time:',
    '_9482_FINISH_TIME_': 'Finish time:',
    '_9483__METRIC_GOAL': 'Metric Goal',
    '_9484___TO_GOAL_': '% To Goal:',
    '_9485___TO_TARGET_': '% To Target:',
    '_9667_CHANGE_FOCUS': 'Change Focus',
    '_9668_UPDATE_COMMITMENT': 'Update Commitment',
    '_534_EVALUATION': 'Evaluation',
    '_9669_SELECT_A_VALUE_FOR_WILLINGNESS_TO_TRY': 'Select a value for Willingness to Try',
    '_9670_SELECT_A_VALUE_FOR_THE_PROFICIENCY_SCORE': 'Select a value for the Proficiency Score',
    '_9486_CREATOR_': 'Creator:',
    '_9488_ADD_COMMITMENT_NOTE': 'Add Commitment Note',
    '_9489_YOU_ARE_LEAVING_THIS_SESSION_': 'You are leaving this session.',
    '_9490_LEAVE': 'Leave',
    '_9491_STAY': 'Stay',
    '_9492_WARNING': 'Warning',
    '_9493_YOU_ARE_CHANGING_THE_SESSION_TIME_': 'You are changing the session time.',
    '_9671_COMMIT': 'Commit',
    '_9672_JUST_PUBLISH': 'Just Publish',
    '_9673_THE_FOCUS_YOU_SELECTED_IN_THE_OBSERVATION_WILL_BE_USED_FOR_THE_COMMITMENT__DO_YOU_WANT_TO_PROCEED_': 'The Focus you selected in the Observation will be used for the Commitment. Do you want to Proceed?',
    '_9674_YOU_ARE_PUBLISHING_AN_OBSERVATION__DO_YOU_WANT_TO_UPDATE_OR_CREATE_A_COMMITMENT_': 'You are publishing an Observation. Do you want to update or create a commitment?',
    '_9583_DO_YOU_WANT_TO_EDIT_THIS_OBSERVATION_': 'Do you want to edit this observation?',
    '_9675_DO_YOU_WANT_TO_EDIT_THE_COMMITMENT_': 'Do you want to edit the commitment?',
    '_9556_DO_YOU_WANT_TO_CREATE_A_NEW_COMMITMENT_': 'Do you want to create a new commitment?',
    '_9495_PRE_APPROVAL': 'Pre-Approval',
    '_9496_DELETED': 'Deleted',
    '_8702_UPDATING': 'Updating',
    '_9497_DATE___TIME_': 'Date & Time:',
    '_9498_DO_YOU_WANT_TO_DELETE_THIS_DRAFT_GOAL_': 'Do you want to Delete this Draft Goal?',
    '_9552_SG_': 'SG:',
    '_9676_OA_': 'OA:',
    '_9677_VIEWING_': 'Viewing:',
    '_97_SEARCH_RESULTS': 'Search Results',
    '_9678_EVENT_TYPE': 'Event Type',
    '_9679_UPDATE_EVENT': 'Update Event',
    '_9680_CANCEL_EVENT': 'Cancel Event',
    '_9681_PARTICIPANTS': 'Participants',
    '_9682_SELECT_A_DATE': 'Select a Date',
    '_9683_DATE_CREATED_': 'Date Created:',
    '_9684_FROM': 'From',
    '_9685__TO': 'To',
    '_9686_NO_GOALS_': 'No Goals.',
    '_9569_TODAY': 'Today',
    '_9687_PERFORMER_': 'Performer:',
    '_9688_SHOW_ALL': 'Show All',
    '_9689_SHOWING_BY_': 'Showing by:',
    '_9690_PLEASE_CHANGE_THE_EVENT_TIME__IT_OVERLAPS_WITH_OTHER_EVENT': 'Please change the event time, it overlaps with other event',
    '_9691_INVITE_PEOPLE': 'Invite People',
    '_9692_COMMITMENTS_SELECTED': 'Commitments Selected',
    '_705_UPDATE': 'Update',
    '_9693_ASSOCIATE': 'Associate',
    '_9694_SELECT_COMMITMENTS': 'Select Commitments',
    '_9695_NO_COMMITMENTS': 'No Commitments',
    '_9696_SELECT_EVENT_TYPE': 'Select Event Type',
    '_9697_SELECT_A_COMMITMENT': 'Select a Commitment',
    '_9823_ACTION_REQUIRED_ON_GOAL': 'Action Required on Goal',
    '_9809_MISSED': 'Missed',
    '_8703_DISPUTED': 'Disputed',
    '_9791_PENDING_APPROVAL': 'Pending Approval',
    '_9824_EXP__ACHIEVEMENT_DATE': 'Exp. Achievement date',
    '_9845_FRONT_LINE_OA': 'Front Line OA',
    '_11051_FOCUS_SELECTOR': 'Focus Selector'
};
